<template>
  <a @click="onClick" :class="linkClass">
    <slot>
      <Icon :name="network.icon" width="54"/>
    </slot>
  </a>
</template>
<script>
import {socialNetworks} from "@/domain/checkinDetail/constants";

export default {
  name: "Sharer",
  emit: ['click'],
  props: {
    network: {
      type: Object,
      required: true
    },
    urlToShare: {
      type: String,
      required: true
    },
    eventName: {
      type: String,
      required: true
    },
    linkClass: {
      type: String,
      default: 'nav-link'
    }
  },

  methods: {
    onClick() {

      const {url, options} = this._buildUrl()
      window.open(url, this.network.network, options)

      this.$emit('click', this.network.network)
    },
    _buildUrl() {
      const text = this.$tc('pages.checkins_detail.share_text', this.eventName, {event: this.eventName})
      const textShort = this.$t('pages.checkins_detail.share_text_short')
      const shareUrl = this.urlToShare.replace('[network]', this.network.name)
      let url = this.network.urlTemplate.replace('_TEXT_', text).replace('_URL_',shareUrl).replace('_TEXT_SHORT_', textShort)

      const width = 560, height = 560
      const top = Math.floor((screen.height - height) / 2)
      const left = Math.floor((screen.width - width) / 2)
      const options = this.network !== socialNetworks.EMAIL ? `width=${width},height=${height},top=${top},left=${left}` : ''

      return {url, options}
    }
  }
}
</script>


<style scoped>

</style>